import React from 'react';

import { PageTitle } from '../../Text';

export default () => (
  <div className="primary-content">
    <PageTitle>Card Holders Details</PageTitle>
    <p>
      This section relates to the Card Holders personal information. If you are applying on
      behalf of the Card Holder, please ensure their personal details are entered.
    </p>
  </div>
);
